export const ChainPresets = {
  // Ethereum
  1: '692ed6ba-e569-459a-556a-776476829e00',
  // Arbitrum
  42161: '600a9a04-c1b9-42ca-6785-9b4b6ff85200',
  // Avalanche
  43114: '30c46e53-e989-45fb-4549-be3bd4eb3b00',
  // Binance Smart Chain
  56: '93564157-2e8e-4ce7-81df-b264dbee9b00',
  // Fantom
  250: '06b26297-fe0c-4733-5d6b-ffa5498aac00',
  // Optimism
  10: 'ab9c186a-c52f-464b-2906-ca59d760a400',
  // Polygon
  137: '41d04d42-da3b-4453-8506-668cc0727900',
  // Gnosis
  100: '02b53f6a-e3d4-479e-1cb4-21178987d100',
  // EVMos
  9001: 'f926ff41-260d-4028-635e-91913fc28e00',
  // ZkSync
  324: 'b310f07f-4ef7-49f3-7073-2a0a39685800',
  // Filecoin
  314: '5a73b3dd-af74-424e-cae0-0de859ee9400',
  // Iotx
  4689: '34e68754-e536-40da-c153-6ef2e7188a00',
  // Metis,
  1088: '3897a66d-40b9-4833-162f-a2c90531c900',
  // Moonbeam
  1284: '161038da-44ae-4ec7-1208-0ea569454b00',
  // Moonriver
  1285: 'f1d73bb6-5450-4e18-38f7-fb6484264a00'
} as Record<string, string | undefined>
